export default __webpack_public_path__ + "static/media/values5.ccf45f52.svg";